import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="w-full flex justify-center py-4 md:py-6" data-id="element-309">
      <motion.div initial={{
      width: 0,
      opacity: 0
    }} whileInView={{
      width: '100px',
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="h-[1px] bg-brand-gold" data-id="element-310" />
    </div>;
}